// extracted by mini-css-extract-plugin
export default {"emptyReportText":"emptyReportText-MeFyC","scoreTest":"scoreTest-hVqAa"};